module.exports = __webpack_public_path__ + "img/sleepingbeauty.5d705a16.jpg";